// extracted by mini-css-extract-plugin
export default {"card":"Card_card__OCIF4","title":"Card_title__R0zIF","img":"Card_img__CoACb","content":"Card_content__iqdhD","ex":"Card_ex__wnC7x"};